import { useContext, useState,useEffect  } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { UserContext } from "../contexts/UserContext";
import { TextField, Button, Box, Typography, Grid, FormControlLabel, Checkbox} from "@mui/material";
import img1 from "../assests/images/img6.png"
import img2 from "../assests/images/bg.png"


export default function RegisterPage() {
  const { setUserInfo } = useContext(UserContext);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [signedToNewsletter, setSignedToNewsletter] = useState(true); // Default to true

  const [redirect, setRedirect] = useState(false);
  const [singingIn, setSigningIn] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false)
  const [signUpMessage, setSignUpMessage] = useState('')
  const navigate = useNavigate();
  const location = useLocation(); // Get location state

  const previousPath = location.state?.from?.pathname;
  const from = (previousPath === '/login' || previousPath === '/register') ? '/blog' : previousPath || '/';

  async function register(ev) { 
    ev.preventDefault();
    
    try {
      setSigningIn(true)
      // Step 1: Register the user
      const registerResponse = await fetch(`${process.env.REACT_APP_API_END_POINT}/register`, {
        method: 'POST',
        body: JSON.stringify({ username, password, email, signedToNewsletter }),
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include' // Include cookies for session handling
      });
      
      const registerData = await registerResponse.json();
      
      if (registerResponse.status === 201) {
        // If registration is successful, log in the user automatically
        setSignUpMessage('Registration successful! Logging you in...');
        setIsLoggingIn(true);
  
        // Step 2: Automatically log in the user after successful registration
        const loginResponse = await fetch(`${process.env.REACT_APP_API_END_POINT}/login`, {
          method: 'POST',
          body: JSON.stringify({ username, password }),
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include' // Include cookies for session handling
        });
  
        if (loginResponse.ok) {
          // Step 3: Handle successful login
          const userInfo = await loginResponse.json();
          setUserInfo(userInfo); // Update user context or state
          setRedirect(true);     // Redirect user to the appropriate page
        } else {
          const loginData = await loginResponse.json();
          setSignUpMessage(`Login failed: ${loginData.message || 'Please try logging in manually.'}`);
        }
        
      } else if (registerResponse.status === 400 && registerData.message === 'Username already taken') {
        // Handle if the username is already taken
        setSignUpMessage('Registration failed: Username is already taken.');
      } else {
        // Generic error message for registration failure
        setSignUpMessage(`Registration failed: ${registerData.message || 'Please try again.'}`);
      }
      
    } catch (err) {
      // Catch and display any network or unexpected errors
      setSignUpMessage('An unexpected error occurred. Please try again.');
    } finally {
      
      
    }
  }
  
  
    // Use useEffect to handle redirect after successful login
    useEffect(() => {
      if (redirect) {
        const timeoutId = setTimeout(() => {
          navigate(from); // Navigate to 'from' path or '/blog' if it was '/login' or '/register'
        }, 500); // Adjust delay as needed
        
        return () => clearTimeout(timeoutId); // Cleanup timeout on component unmount
      }
    }, [redirect, navigate, from]);

    return (
      <Grid container component="main" sx={{  }}>
  
         {/* Right side with image and plan details */}
         <Grid
            item
            xs={false}
            sm={false}
            md={8}
  
            sx={{
              backgroundColor: "white",
              display: "flex",
          height: "90vh",
            justifyContent:'space-between',
              
        
            
            }}
          >
  
                {/* First row: Image with overlay */}
                <Grid
                container 
                md={7}
                  sx={{
                    width: "100%",           // Ensure the box takes full width of the container
                    height: "100%",          // Set height to make the image visible
                    backgroundImage: `url(${img1})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center top',
                
                    position: 'relative',
                                  // Add margin between rows
                  }}
                >
               
                </Grid>
  
     {/* Second row: Text section */}
     <Grid container md={5}     sx={{
                    width: "100%",           // Ensure the box takes full width of the container
                    height: "120%",          // Set height to make the image visible
                    backgroundImage: `url(${img2})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                    backgroundPosition: 'top',
                
                    position: 'relative',
                                  // Add margin between rows
                  }}
                >
  
            </Grid>
  
   
  
   
         </Grid>
  
          {/* add the checbox here  */}
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          component={Box}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          sx={{ padding: "2rem 3rem", bgcolor:"#faebe1" , }}
        >
          <Box sx={{ width: "100%",  height:'100%',  }}>
          {singingIn && (
        <Typography variant="body1" gutterBottom className="msg">
       { signUpMessage}
          </Typography>
  
        )}
  
          
            <Typography variant="h6" gutterBottom className="heading">
                Welcome to Chef Adel's Blog
              </Typography>
              <Typography variant="body2" textAlign="start" gutterBottom className="body" sx={{fontSize: {sm:'0.3rem', xs:'0.3rem'}}}>
            
                Whether you're an aspiring chef, food enthusiast, or restaurant manager, 
                this blog is your go-to destination for delicious food inspiration and expert advice.
              </Typography>
              <Typography variant="body2" textAlign="start" className="body">
                Join our community and take your culinary skills to the next level!
              </Typography>
  
            <Box component="form" onSubmit={register} sx={{ mt: 1 }}>
              
            <TextField
                margin="normal"
                fullWidth
                label="Email"
                value={email}
                onChange={(ev) => setEmail(ev.target.value)}
              />
              <TextField
                margin="normal"
                fullWidth
                label="username"
                value={username}
                onChange={(ev) => setUsername(ev.target.value)}
              />
              <TextField
                margin="normal"
                fullWidth
                label="Password"
                type="password"
                value={password}
                onChange={(ev) => setPassword(ev.target.value)}
              />
              <Button
              disabled={!email|| !username || !password || isLoggingIn } 
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                sx={{ mt: 3, mb: 2, backgroundColor: "#ca7735" }}
              >
               {isLoggingIn ? "One moment please..." : 'Create account'} 
              </Button>

               {/* Checkbox for signing up to newsletter */}
          <FormControlLabel
            control={
              <Checkbox
                checked={signedToNewsletter}
                onChange={(e) => setSignedToNewsletter(e.target.checked)}
                
                sx={{
                  '&.MuiCheckbox-root.Mui-checked' :{color:'#d3752b'}
                }}
              />
            }
            label="Sign me up to the newsletter."
          />
             <Typography variant="body2" sx={{ textAlign: "start", mb:3 }}>
             You'll receive personalized recommendations about recipes, cooking tips, and much more.
              </Typography>

              <Typography variant="body2" sx={{ textAlign: "center" }}>
                Already have an account?{" "}
                
                <Link to="/login" underline="hover" className="link blue-text">
               Log in
              </Link>
              </Typography>
            </Box>
          </Box>
        </Grid>
  
       
  
      </Grid>
    );
}